import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import HomeScreen from '../components/sms-mpm-20/home-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { ScreensContext } from '../contexts/screensContext';
import { getImageFromS3 } from '../imageService';
import useScreenHistory from '../hooks/useScreenHistory';

const NewLanding2 = () => {
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 0
  });
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('25-sms-mpm-20');
    sendEvent('age_verification_without');
    sessionStorage.setItem('unsubscription_source', 'mpm_20');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 0: {
        return (
          <HomeScreen
            backgroundImage={`url("${getImageFromS3(
              'images/sms-mpm-20/bg.png'
            )}")`}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, setScreenNumber)}
    </ScreensContext.Provider>
  );
};

export default NewLanding2;
